export const privilegeCode = {
  REJECTED: '用户无资格申请或使用此特权',
  UNSUBMITTED: '用户有资格但需要用户主动提交申请',
  REVIEWING: '用户已提交申请, 待管理员审核',
  ACCEPTED: '已授权',
}

export const eventTypeCode = {
  TYPE_PLAY: '播放视频或音频',
  TYPE_VIEW: '查看文件',
  TYPE_CREATE: '创建文件',
  TYPE_UPDATE: '更新文件',
  TYPE_DOWNLOAD: '下载文件',
  TYPE_DELETE: '删除文件',
  TYPE_UPLOAD: '上传文件',
  TYPE_RESTORE: '转存文件',
}

export const taskPhaseCode = {
  PHASE_TYPE_PENDING: '等待添加...',
  PHASE_TYPE_RUNNING: '正在添加',
  PHASE_TYPE_ERROR: '添加失败',
  PHASE_TYPE_COMPLETE: '已存到云盘',
}

export const taskPhaseCodeReport = {
  PHASE_TYPE_PENDING: 'add_wait',
  PHASE_TYPE_RUNNING: 'adding',
  PHASE_TYPE_ERROR: 'add_fail',
  PHASE_TYPE_COMPLETE: 'add_finish',
}

export const shareStatusCode = {
  OK: 0,
  PASS_CODE_EMPTY: 1,
  PASS_CODE_ERROR: 2,
  MAX_RESTORE_COUNT: 3,
  EXPIRED: 4,
  DELETED: 5,
  SENSITIVE: 6,
  SENSITIVE_WORD: 6,
  SENSITIVE_RESOURCE: 6,
  AUDITING: 7,
  NOT_FOUND: 8,
}

export const shareStatusTxt = [
  'OK',
  '需要提取码',
  '提取码错误',
  '来晚了，该文件已超出分享次数',
  '来晚了，该文件已过期',
  '抱歉，该分享已被作者删除',
  '该分享内容可能因为涉及侵权、色情、反动、低俗等信息，无法访问！',
  '您访问的链接内容正在审核中...<br>请稍后访问，链接即将生效',
  '当前分享不存在，请检查链接',
]
export function pub3JNq3xcp7NrvoqHyxPeb8dezstJNtbt2 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'clJArKk3utHQPcgdR1ZMp4ktgZfxKAc2wrlB7BxcSQw', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./util.js').pubevHI5Px9f3KdFtJtko6WIiVPPvQIwPDD
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubEcPbppGc6zTTYnWT9ak3PgVRBtLtDaLa (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./qrImg.js').pubKFFcpZbE9Gnf86LeKJ24HDiNncd5FGtl
            const nextPart2 = require('./stat.js').pubSz10mLzcvULI6nEQ99mZ1bnW1zBKxIE7
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubm334ZheusVEXiDtyIPQXW9Rx4TKwvBph (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./error-message.js').pubv8n1pIFkGwMu5pVmmeRksOrTHT9pUA0v
            const nextPart2 = require('./captcha.js').pubT7Hbx03hVwz9B0FrX4lBPbhDYgJZAmPw
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubp1NBskJbZ2ZAm2yN76eT01Ocbqbyr1ok (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./stat.js').pubIWWqPnwo6THdRHzgGfWNiv6h7VoBW0o3
            const nextPart2 = require('./util.js').pubJKpCGHUnv4IHTUezh7yg3LXuRGKc6VhD
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubHPJWeRriP29r8lm20QdQ8KuwdLT8LqZx (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: 'rsdGznYu8NxTDRXFxwJdfeT+qGGvJm3b250gQGiHmlV', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./captcha.js').pub9TGPJ47k46xZbBTkuv0cwjtEA6BeIb5l
              const nextPart2 = require('./error-message.js').pub40923yUDwTCBq734Mu45JxELmYgnFi2n
              return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }